// Centralized Yandex Metrica tracking helpers
const YM_COUNTERS = [98619707, 98641993] as const;

type AnalyticsParams = Record<string, unknown>;

// Send page hit to all configured counters
export const trackHit = (url?: string, params?: AnalyticsParams) => {
  const path = url ?? window.location.pathname + window.location.search;
  const options = { title: document.title, ...params };
  const ym = window.ym; // Narrow to local to preserve type guard in callback
  if (typeof ym === "function") {
    YM_COUNTERS.forEach((id) => ym(id, "hit", path, options));
  }
};

// Send reachGoal to all configured counters
export const trackGoal = (goal: string, params?: AnalyticsParams) => {
  const ym = window.ym; // Narrow to local to preserve type guard in callback
  if (typeof ym === "function") {
    YM_COUNTERS.forEach((id) => ym(id, "reachGoal", goal, params));
  }
};